import { render } from "./CrudFilaVeiculo.vue?vue&type=template&id=6dab6441"
import script from "./CrudFilaVeiculo.vue?vue&type=script&lang=ts"
export * from "./CrudFilaVeiculo.vue?vue&type=script&lang=ts"
script.render = render

export default script